import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {setUpdateButtonActiveStepToFalse,
        setUpdateButtonActiveStepToTrue
       } from '../../../../store/actions/main';
import {updateGrundrissGelaender,
       updateWrapperIndexGelaender,
       updateStepsGelaender
      } from '../../../../store/actions/gelaender';
import {grundriss_auswahl} from '../../../../../assets/images/data';
import scrollToElement from '../../../../module/scrollToElement';


const Step_3 = (props) => {

   useEffect(() => {
      updateItems();
   })

   const updateItems = () => {
      let form = props.data[props.modell_type].layout;
      let wrapper_index = props.data[props.modell_type].wrapper[0].wrapper2;
      let formWrapper = document.querySelectorAll('.formWrapper');

      for (let i = 0; i < formWrapper.length; i++) {
         formWrapper[i].classList.remove('check');
      }

      if (form) formWrapper[wrapper_index].classList.add('check');

      //scroll to Next Button Container
      scrollToElement();

      //update steps
      if (props.modell_type === 3) props.updateSteps(0);
      else props.updateSteps(1);

      //Weiter-Button aktivieren
      if (form || props.data[props.modell_type].allVisitedSteps) {
          //update steps
         if (props.modell_type === 3) props.updateSteps(1);
         else props.updateSteps(2);

         props.setUpdateButtonActiveStepToFalse();
      } else {
         props.setUpdateButtonActiveStepToTrue();
      }


   }

   const selectForm = ev => {
      let form = ev.currentTarget.getAttribute('titel');
      let wrapperObject = {
         ident: 2,
         index: ev.currentTarget.getAttribute('index')
      }
      props.updateWrapperIndex(wrapperObject);
      props.updateGrundrissGelaender(form);
      updateItems();
   }

   return (
           <div className="step_wrapper">
             <h2 className="step_header">Wählen Sie einen passenden Grundriss für das Geländers aus</h2>
               <div className="step_icon_wrapper">
                 <div className="inner_form_wrapper inner_wrapper_row">
                     {grundriss_auswahl.map((elem, index) => (
                           <div key={index} className="formWrapper" onClick={selectForm} titel={elem.titel} index={index}>
                              <img className="imgform grundriss" src={elem.imgsrc} alt={elem.imgalt} />
                              <p>{elem.titel}</p>
                           </div>
                        ))
                     }
                </div>
              </div>
          </div>
       )
}

const mapStateToProps = state => {
    return {
      modell_type: state.gelaenderReducer.modell_type,
      data: state.gelaenderReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      updateGrundrissGelaender: ev => dispatch(updateGrundrissGelaender(ev)),
      updateWrapperIndex: ev => dispatch(updateWrapperIndexGelaender(ev)),
      updateSteps: ev => dispatch(updateStepsGelaender(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_3);
